import React from "react";
import img1 from "../../../Assets/Homeimgs/Instructor.svg";
import img2 from "../../../Assets/Homeimgs/Education.svg";

const BecomeAnInstructor = () => {
  const cards = [
    {
      id: 1,
      label: "Teach with Us",
      title: "Become an Instructor",
      desc: "Top instructors from around the world teach students on our platform. Share your knowledge and grow your impact.",
      cta: "Join as Instructor",
      image: img1,
      aos: "fade-right",
    },
    {
      id: 2,
      label: "Shape the Future",
      title: "Transform Access to Education",
      desc: "Create an account to reach more learners, share your expertise, and be part of our growing mentor community.",
      cta: "Start Today",
      image: img2,
      aos: "fade-left",
    },
  ];

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#eef3ff] via-[#f7f5ff] to-white">
      {/* Glow orbs (same style as other sections) */}
      <div className="pointer-events-none absolute -top-32 -left-32 h-80 w-80 rounded-full bg-[#064585]/25 blur-3xl" />
      <div className="pointer-events-none absolute top-40 -right-32 h-96 w-96 rounded-full bg-[#5989C8]/25 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-8 md:py-12 lg:py-14">
        {/* Small heading */}
        <div className="flex flex-col gap-2 mb-6 md:mb-8" data-aos="fade-up">
          <p className="text-[10px] text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-[#064585]">
            Collaborate & Grow
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-slate-900">
            Build the{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#64a2ff] via-[#5989C8] to-[#064585]">
              future of learning
            </span>{" "}
            with us
          </h2>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {cards.map((card) => (
            <div
              key={card.id}
              className="group bg-white/80 backdrop-blur border border-[#5989C8]/20 rounded-3xl shadow-md p-5 sm:p-6 md:p-7 flex items-center gap-4 md:gap-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:border-[#064585]/40"
              data-aos={card.aos}
            >
              {/* Left: text */}
              <div className="flex-1">
                <span className="inline-flex items-center px-3 py-1 rounded-full text-[11px] font-semibold uppercase tracking-[0.2em] bg-[#eef3ff] text-[#064585]">
                  {card.label}
                </span>

                <h3 className="mt-3 text-lg sm:text-xl md:text-2xl font-semibold text-slate-900">
                  {card.title}
                </h3>

                <p className="mt-2 text-sm sm:text-base text-slate-600">
                  {card.desc}
                </p>

                <div className="mt-4 flex items-center gap-3">
                  <button className="bg-gradient-to-r from-[#5989C8] to-[#064585] text-white px-5 py-2.5 rounded-full text-sm sm:text-base font-semibold shadow-md hover:shadow-lg transition">
                    {card.cta}
                  </button>
                </div>
              </div>

              {/* Right: image */}
              <div className="hidden sm:flex justify-end flex-shrink-0">
                <div className="relative">
                  {/* accent ring */}
                  <div className="absolute -inset-2 rounded-3xl border border-dashed border-[#5989C8]/40 opacity-0 group-hover:opacity-100 transition" />
                  <div className="bg-white/80 backdrop-blur rounded-2xl p-3 shadow-inner">
                    <img
                      src={card.image}
                      alt={card.title}
                      className="w-28 h-28 md:w-32 md:h-32 object-contain"
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BecomeAnInstructor;
